import React from 'react';

const SentryRow = ({className = "", children}) => {
    return (
        <section className={["grid grid-cols-12 gap-x-4 gap-y-3", className].join(" ")}>
            {children}
        </section>
    );
};

export default SentryRow;